// Context que expone los productos reales del usuario a todos los
// componentes de Interfaz V2 que los necesitan (pickers, chips de
// resumen, tool cards del chat, etc.). Antes los componentes leían
// `MOCK_USER_PRODUCTS` directo del módulo — esto los conecta a la data
// real fetchada por `fetchUserProducts(companyId)`.
//
// Default = array vacío. Si todavía no se cargaron, los pickers muestran
// estado vacío (no rompe nada).

import { createContext, useContext } from 'react';
import type { MockProductV2 } from './mockData';

export const ProductsContext = createContext<MockProductV2[]>([]);

export const useUserProducts = (): MockProductV2[] => useContext(ProductsContext);
